const Groups = {
  STUDENTS: 'students',
  COACHES: 'coaches',
  EDITORS: 'editors',
  DRAFTS: 'drafts',
  ALL: 'all'
};

export default Groups;
